import { render, staticRenderFns } from "./InputToken.vue?vue&type=template&id=d48a4f22&"
import script from "./InputToken.vue?vue&type=script&lang=js&"
export * from "./InputToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports